import { Icon } from '@types-custom/models/ui/icon-model';
import {
  IndicatorApiModel,
  IndicatorModel,
} from '@types-custom/models/ui/indicators.model';

export const generateIndicatorsModel = (
  indicator: IndicatorApiModel
): IndicatorModel[] => {
  return [
     {
      icon: Icon.camera_indicator,
      tooltipTag: `Puntos
      de aforo`,
      data: indicator.camerasCount,
    },
    {
      icon: Icon.basura_indicator,
      tooltipTag: `Puntos de basuras`,
      data: indicator.bucketTrucksCount,
    },
    {
      icon: Icon.air_indicator,
      tooltipTag: `Calidad del aire`,
      // tooltipTag: '(μg/m³N)',
      data: indicator.airQualityIndex,
    },
    {
      icon: Icon.parking_indicator,
      tooltipTag: `Porcentaje de 
      ocupación parqueaderos`,
      data: indicator.parkingAverageOccupancy,
    },
    {
      icon: Icon.sound_indicator,
      tooltipTag: `Nivel de ruido
      (Decibeles)`,
      data: indicator.soundLevel,
    },
    // {
    //   icon: Icon.underground_parking,
    //   tooltipTag: 'Porcentaje de ocupación parking subterráneo en los últimos 5 minutos',
    //   data: indicator.subparkingPercentage,
    // },
  ];
};
